import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esHeader from "./locales/es/header.json";
import enHeader from "./locales/en/header.json";
import jaHeader from "./locales/ja/header.json";
import esConfiguracion from "./locales/es/configuracion.json";
import enConfiguracion from "./locales/en/configuracion.json";
import jaConfiguracion from "./locales/ja/configuracion.json";
import esSidebar from "./locales/es/sidebar.json";
import enSidebar from "./locales/en/sidebar.json";
import jaSidebar from "./locales/ja/sidebar.json";
import esDashboard from "./locales/es/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import jaDashboard from "./locales/ja/dashboard.json";
import esReports from "./locales/es/reports.json";
import enReports from "./locales/en/reports.json";
import jaReports from "./locales/ja/reports.json";
import esFinance from "./locales/es/finance.json";
import enFinance from "./locales/en/finance.json";
import jaFinance from "./locales/ja/finance.json";
import esDocuments from "./locales/es/documents.json";
import enDocuments from "./locales/en/documents.json";
import jaDocuments from "./locales/ja/documents.json";
import esCobranza from "./locales/es/cobranza.json";
import enCobranza from "./locales/en/cobranza.json";
import jaCobranza from "./locales/ja/cobranza.json";
import esTaxes from "./locales/es/taxes.json";
import enTaxes from "./locales/en/taxes.json";
import jaTaxes from "./locales/ja/taxes.json";
import esAccounting from "./locales/es/accounting.json";
import enAccounting from "./locales/en/accounting.json";
import jaAccounting from "./locales/ja/accounting.json";
import esRepository from "./locales/es/repository.json";
import enRepository from "./locales/en/repository.json";
import jaRepository from "./locales/ja/repository.json";
import esConnections from "./locales/es/connections.json";
import enConnections from "./locales/en/connections.json";
import jaConnections from "./locales/ja/connections.json";
import esAgenda from "./locales/es/agenda.json";
import enAgenda from "./locales/en/agenda.json";
import jaAgenda from "./locales/ja/agenda.json";
import esCreditCards from "./locales/es/creditCards.json";
import enCreditCards from "./locales/en/creditCards.json";
import jaCreditCards from "./locales/ja/creditCards.json";
import esDownloads from "./locales/es/downloads.json";
import enDownloads from "./locales/en/downloads.json";
import jaDownloads from "./locales/ja/downloads.json";
import esValidadorLiquidaciones from "./locales/es/validadorLiquidaciones.json";
import enValidadorLiquidaciones from "./locales/en/validadorLiquidaciones.json";
import jaValidadorLiquidaciones from "./locales/ja/validadorLiquidaciones.json";
import esHaberesVariables from "./locales/es/haberesVariables.json";
import enHaberesVariables from "./locales/en/haberesVariables.json";
import jaHaberesVariables from "./locales/ja/haberesVariables.json";
import esFichaCliente from "./locales/es/fichaCliente.json";
import enFichaCliente from "./locales/en/fichaCliente.json";
import jaFichaCliente from "./locales/ja/fichaCliente.json";
import { readStoredAppLanguage } from "./utils/appLanguage";

const namespaces = {
  header: { es: esHeader, en: enHeader, ja: jaHeader },
  configuracion: { es: esConfiguracion, en: enConfiguracion, ja: jaConfiguracion },
  sidebar: { es: esSidebar, en: enSidebar, ja: jaSidebar },
  dashboard: { es: esDashboard, en: enDashboard, ja: jaDashboard },
  reports: { es: esReports, en: enReports, ja: jaReports },
  finance: { es: esFinance, en: enFinance, ja: jaFinance },
  documents: { es: esDocuments, en: enDocuments, ja: jaDocuments },
  cobranza: { es: esCobranza, en: enCobranza, ja: jaCobranza },
  taxes: { es: esTaxes, en: enTaxes, ja: jaTaxes },
  accounting: { es: esAccounting, en: enAccounting, ja: jaAccounting },
  repository: { es: esRepository, en: enRepository, ja: jaRepository },
  connections: { es: esConnections, en: enConnections, ja: jaConnections },
  agenda: { es: esAgenda, en: enAgenda, ja: jaAgenda },
  downloads: { es: esDownloads, en: enDownloads, ja: jaDownloads },
  creditCards: { es: esCreditCards, en: enCreditCards, ja: jaCreditCards },
  validadorLiquidaciones: {
    es: esValidadorLiquidaciones,
    en: enValidadorLiquidaciones,
    ja: jaValidadorLiquidaciones,
  },
  haberesVariables: {
    es: esHaberesVariables,
    en: enHaberesVariables,
    ja: jaHaberesVariables,
  },
  fichaCliente: {
    es: esFichaCliente,
    en: enFichaCliente,
    ja: jaFichaCliente,
  },
};

const ns = Object.keys(namespaces);

const resources = {
  es: Object.fromEntries(ns.map((name) => [name, namespaces[name].es])),
  en: Object.fromEntries(ns.map((name) => [name, namespaces[name].en])),
  ja: Object.fromEntries(ns.map((name) => [name, namespaces[name].ja])),
};

i18n.use(initReactI18next).init({
  resources,
  lng: readStoredAppLanguage(),
  fallbackLng: {
    ja: ["en", "es"],
    default: ["es"],
  },
  defaultNS: "header",
  ns,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
